var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_6277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5901 14.6668C12.5901 13.0951 11.9658 11.5878 10.8545 10.4765C9.74314 9.36518 8.23586 8.74084 6.66421 8.74084C5.09255 8.74084 3.58527 9.36518 2.47394 10.4765C1.36262 11.5878 0.738281 13.0951 0.738281 14.6668",
    stroke: "#726C6C",
    strokeWidth: 1.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66464 8.74078C8.71014 8.74078 10.3683 7.08258 10.3683 5.03708C10.3683 2.99158 8.71014 1.33337 6.66464 1.33337C4.61914 1.33337 2.96094 2.99158 2.96094 5.03708C2.96094 7.08258 4.61914 8.74078 6.66464 8.74078Z",
    stroke: "#726C6C",
    strokeWidth: 1.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5541 13.926C15.5541 11.4297 14.0726 9.11119 12.5911 8.00008C13.0781 7.63472 13.4675 7.15496 13.7249 6.60324C13.9823 6.05152 14.0997 5.44487 14.0667 4.83697C14.0338 4.22906 13.8515 3.63866 13.5359 3.118C13.2204 2.59735 12.7814 2.16249 12.2578 1.85193",
    stroke: "#726C6C",
    strokeWidth: 1.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8549 13.4074C18.8549 10.9112 17.3734 8.59263 15.8919 7.48152C16.3789 7.11617 16.7683 6.6364 17.0257 6.08468C17.2831 5.53297 17.4005 4.92631 17.3675 4.31841C17.3345 3.71051 17.1522 3.1201 16.8367 2.59945C16.5212 2.07879 16.0822 1.64394 15.5586 1.33337",
    stroke: "#726C6C",
    strokeWidth: 1.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_6277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.8148,
    fill: "white",
    transform: "translate(0 0.592651)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user-3.4f613bca84e53e95b231aa092e5f0aee.svg";
export { ForwardRef as ReactComponent };